module.exports = __webpack_public_path__ + "img/DAVID_CANNON_13-rs.5dfa56bd.jpg";